import apiClient from '@/scripts/api/apiClient';

/**
 * Info API endpoints
 */

// Query key factories
export const infoKeys = {
  getInfo: () => ['get', 'info'],
};

/**
 * Get application info including environment details
 * @returns {Promise<Object>} Application info
 */
export const getInfo = async () => {
  const response = await apiClient.get('/api/info');
  return response.data;
};
